import WatchListEntriesPage from './WatchListEntriesPage';

export default WatchListEntriesPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/pages/watch-list-entries-page/index.js